var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGettingReadyPageResultsClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 0H0V80H80V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6602 6.89001C21.3536 6.89001 6.51167 21.727 6.51167 40.0335C6.51167 58.34 21.3536 73.1771 39.6602 73.1771V53.6011V26.4661V6.89001Z",
    fill: "#151515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9903 63.053C52.7219 63.053 63.0429 52.7319 63.0429 40.0003C63.0429 27.2686 52.7219 16.9476 39.9903 16.9476C27.2586 16.9476 16.9375 27.2686 16.9375 40.0003C16.9375 52.7319 27.2586 63.053 39.9903 63.053Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6816 16.6517V16.0117C52.9213 16.0117 63.6765 26.7607 63.6765 40.0004C63.6765 53.24 52.9213 63.989 39.6816 63.989V63.349C52.5754 63.349 63.0319 52.8862 63.0319 40.0004C63.0319 27.1145 52.5754 16.6517 39.6816 16.6517Z",
    fill: "#151515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9989 43.653C42.0165 43.653 43.652 42.0174 43.652 39.9998C43.652 37.9822 42.0165 36.3466 39.9989 36.3466C37.9813 36.3466 36.3457 37.9822 36.3457 39.9998C36.3457 42.0174 37.9813 43.653 39.9989 43.653Z",
    fill: "#151515"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9982 36.3465C42.015 36.3465 43.6507 37.9835 43.6507 39.9997C43.6507 42.016 42.015 43.653 39.9982 43.653C37.9814 43.653 36.3457 42.016 36.3457 39.9997C36.3457 37.9835 37.9814 36.3465 39.9982 36.3465ZM39.9982 36.9865C38.3358 36.9865 36.9864 38.3368 36.9864 39.9997C36.9864 41.6627 38.3358 43.013 39.9982 43.013C41.6606 43.013 43.0124 41.6627 43.0124 39.9997C43.0124 38.3368 41.6606 36.9865 39.9982 36.9865Z",
    fill: "#151515"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3196 27.668H39.6797V36.9453H40.3196V27.668Z",
    fill: "#151515"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8117 24.8429L43.9706 24.2221C51.0367 25.9966 56.27 32.3921 56.27 39.9996C56.27 48.9768 48.9815 56.2664 39.9979 56.2664C31.0249 56.2664 23.7363 48.9768 23.7363 39.9996C23.7363 32.6495 28.6201 26.432 35.3154 24.4191L35.4955 25.0315C29.065 26.9659 24.372 32.9388 24.372 39.9996C24.372 48.624 31.3745 55.6265 39.9979 55.6265C48.6213 55.6265 55.6238 48.624 55.6238 39.9996C55.6238 32.6909 50.6023 26.5474 43.8117 24.8429Z",
    fill: "#DFE1E1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.73 23.0666L32.041 22.5062L35.6403 24.5033C35.7937 24.5884 35.8484 24.7818 35.7664 24.9361L33.7862 28.5946L33.2229 28.2893L35.052 24.9099L31.73 23.0666Z",
    fill: "#DFE1E1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.058 37.0223L40.4355 36.8704L43.5844 23.9776L44.2052 24.1295L41.058 37.0223Z",
    fill: "#151515"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7493 16.9495C42.5299 16.9495 44.784 14.6954 44.784 11.9148C44.784 9.13427 42.5299 6.88016 39.7493 6.88016C36.9688 6.88016 34.7148 9.13427 34.7148 11.9148C34.7148 14.6954 36.9688 16.9495 39.7493 16.9495Z",
    fill: "#428DFC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3268 54.4872C15.6708 53.921 16.2855 53.5753 16.9479 53.5753C17.6107 53.5753 18.2251 53.921 18.569 54.4872C21.0192 58.5182 25.646 66.1308 28.1707 70.285C28.5267 70.8705 28.5392 71.6028 28.2032 72.2003C27.867 72.7977 27.2351 73.1675 26.5496 73.1675C21.5744 73.1675 12.3218 73.1675 7.34632 73.1675C6.66107 73.1675 6.02889 72.7977 5.69298 72.2003C5.35674 71.6028 5.36916 70.8705 5.72523 70.285C8.24992 66.1308 12.8771 58.5182 15.3268 54.4872Z",
    fill: "#9E007E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7663 73.1663C42.5594 73.1663 44.8237 70.902 44.8237 68.1088C44.8237 65.3157 42.5594 63.0514 39.7663 63.0514C36.9731 63.0514 34.709 65.3157 34.709 68.1088C34.709 70.902 36.9731 73.1663 39.7663 73.1663Z",
    fill: "#23286B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingReadyPageResultsClock);
export default __webpack_public_path__ + "static/media/gettingReadyPage--results__clock.e63ca43e5f9144efaa24452ea2198624.svg";
export { ForwardRef as ReactComponent };